import { Type, screenSmMax, mobileAlto } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
export const Heading = withAnimationContext(styled(Type.h1).attrs({
    variant: 'brio',
    className: 'heading',
}) `
    line-height: 48px;
    ${fadeInAnimation(DELAYS.SECOND)};
    @media (max-width: ${screenSmMax}) {
      ${() => mobileAlto}
      line-height: 32px;
    }
  `);
//# sourceMappingURL=Heading.js.map